/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coveradjust1Inputs */

const en_coveradjust1 = /** @type {(inputs: Coveradjust1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust cover`)
};

const de_coveradjust1 = /** @type {(inputs: Coveradjust1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild anpassen`)
};

/**
* | output |
* | --- |
* | "Adjust cover" |
*
* @param {Coveradjust1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coveradjust1 = /** @type {((inputs?: Coveradjust1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coveradjust1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coveradjust1(inputs)
	return de_coveradjust1(inputs)
});
export { coveradjust1 as "coverAdjust" }